module.exports = __webpack_public_path__ + "static/media/seha-logo.ccc07e6b.png";